<template>
<div>

    <main class="d-flex align-items-center min-vh-100 py-3 py-md-0">
    <div class="container">
      <div class="card login-card">
        <div class="row no-gutters">
          <div class="col-md-5">
            <img src="/set/img/min.png" alt="login" class="login-card-img">
          </div>
          <div class="col-md-7">
            <div class="card-body">
              <div class="brand-wrapper">
                <img src="/set/img/logo.png" alt="logo" class="logo">
              </div>
              <p class="login-card-description"></p>
              <form @submit.prevent="handleSubmit">
                  <div class="form-group">
                    <label for="email" class="sr-only">Kullanıcı Adı</label>
                    <input type="text" v-model="username" name="email" id="email" class="form-control" placeholder="Kullanıcı Adı">
                  </div>
                  <div class="form-group mb-4">
                    <label for="password" class="sr-only">Şifre</label>
                    <input type="password" v-model="password" name="password" id="password" class="form-control" placeholder="***********">
                  </div>
                  <input name="login" id="login" class="btn btn-block login-btn mb-4" type="submit" :value="islem">
                </form>
                <a href="#!" class="forgot-password-link">Parolamı Unuttum</a>
                <nav class="login-card-footer-nav">
                  <a href="#!">Gizlilik ve Güvenlik Politikamız</a> &
                  <a href="#!">KVKK Politikamız </a>
                </nav>
            </div>
          </div>
        </div>
      </div>
       <div v-if="error" class="alert alert-danger">{{error}}</div>
    </div>
  </main>

</div>
</template>

<script>
import { router } from '../router';
//import { userService } from '../_services';

export default {
    data () {
        return {
            username: '',
            password: '',
            submitted: false,
            loading: false,
            returnUrl: '',
            error: '',
            islem:"Giriş Yap",
        }
    },
    created () {
        this.returnUrl = this.$route.query.returnUrl || '/';
    },
    methods: {
        handleSubmit (e) {
          this.islem = "Bekleyiniz"

            this.submitted = true;
            const { username, password } = this;

            if (!(username && password)) {
                return;
            }
            this.loading = true;
            this.$helper.login(username, password)
                .then(res => {
                    if (res.status){
                      this.error = "Müşteri List Getiriliyor"
                      setTimeout(() => {
                      this.$request.post("servis/api", {q:'cari_adres',where:{},isim: this.$request.ayar().f1}).then(cari => {
                        this.$store.dispatch("source",cari.data).then(ok=>{
                          router.push(this.returnUrl)
                        })
                      }).catch(err=>{
                        this.error ='Müşteriler Getirilemedi';
                        this.loading = false
                      })                        
                      },500);
                 
                    }
                    else{
                        this.error ='Bilgiler hatalı ya da yetkisiz kullanıcı';
                        this.loading = false
                      }
                })
                .catch (err => {
                  console.log(err)
                  this.error = err;
                this.loading = false;})
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/login/LoginPage.vue